import React from 'react'

import { DropdownContentControlled as DSDropdownContentControlled } from '@mc/design-system'

import classes from './DropdownContent.module.scss'

type DropdownContentControlledProps = {
  show: boolean
  setShow(s: boolean): void
  children: React.ReactNode
  style?: React.CSSProperties
}

export const DropdownContentControlled = ({
  show,
  setShow,
  children,
  style,
}: DropdownContentControlledProps) => (
  <DSDropdownContentControlled
    show={show}
    onClose={() => setShow(false)}
    className={`${classes.dropdownContent} mc-w-100 mc-pt-2`}
    style={style}
  >
    {children}
  </DSDropdownContentControlled>
)
